import { FetchBaseQueryArgs } from '@reduxjs/toolkit/dist/query/fetchBaseQuery'

const auth = {
  token: () => {
    const keys = Object.keys(sessionStorage)
    const tokenKey = keys.find(key => key.startsWith('oidc.user:'))
    return tokenKey ? JSON.parse(sessionStorage.getItem(tokenKey) as string).access_token : null
  },
}

export const adminBaseQuery: FetchBaseQueryArgs = {
  baseUrl: BASE_API_URL,
  prepareHeaders: async headers => {
    const token = await auth.token()
    headers.set('Authorization', `Bearer ${token}`)
    return headers
  },
}

export const customerBaseQuery: FetchBaseQueryArgs = {
  baseUrl: BASE_API_URL,
}

export const publicBaseQuery: FetchBaseQueryArgs = {
  baseUrl: BASE_PUBLIC_API_URL,
  prepareHeaders: async headers => {
    // Required to authorize requests to the public API
    headers.set('Referer', window.location.origin)
    return headers
  },
}

export const tagTypes = ['Admin', 'Customer']
